import { useLazyQuery, useQuery } from '@apollo/client'
import { SLIDES_ATIVOS } from '../data/slides-ativos-query'
import { linkDownloadByArquivoQueryGql } from '@/core/components/uploader-utils'
import { useCallback, useEffect, useState } from 'react'

export const useCarousel = () => {
  const { data, loading } = useQuery(SLIDES_ATIVOS)
  const [fetchImage] = useLazyQuery(linkDownloadByArquivoQueryGql)
  const [images, setImages] = useState([])

  const loadImages = useCallback(async () => {
    const loadedImages = await Promise.all(
      (data?.slidesAtivos ?? []).map(async slide => {
        const {
          titulo,
          corTitulo,
          tamanhoTitulo,
          subtitulo,
          corSubtitulo,
          tamanhoSubtitulo,
          tituloBotao,
          link,
          linkTarget,
          arquivo
        } = slide
        const { data } = await fetchImage({
          variables: {
            idArquivo: arquivo.id
          }
        })

        return {
          src: data?.linkDownloadByArquivo,
          alt: titulo,
          title: {
            text: titulo,
            color: corTitulo,
            size: `${tamanhoTitulo}px`
          },
          subtitle: {
            text: subtitulo,
            color: corSubtitulo,
            size: `${tamanhoSubtitulo}px`
          },
          button:
            (tituloBotao ?? []).length > 0
              ? { title: tituloBotao, link, target: linkTarget }
              : undefined
        }
      })
    )
    setImages(loadedImages)
  }, [data?.slidesAtivos])

  useEffect(() => {
    loadImages().then()
  }, [data?.slidesAtivos, loadImages])
  return {
    loading,
    data,
    images
  }
}
